import React from 'react';
import { Typography, Box } from '@mui/material';
import packageJson from '../../../../package.json';

interface AppVersionProps {
    align?: 'left' | 'center' | 'right';
    marginTop?: number;
    marginBottom?: number;
    muted?: boolean;
    styled?: boolean
}

const AppVersion: React.FC<AppVersionProps> = ({
    align = 'center',
    marginTop = 2,
    marginBottom = 2,
    muted = true,
    styled = true
}) => {
    const version = packageJson.version.startsWith('1.') ? '2.0.0' : packageJson.version; //note: temporary setting version to 2.0.0 as CD workflow is not currently updating `packageJson.version` value, might delete this validation later

    const renderVersion = <Typography
        variant="caption"
        color={muted ? 'text.secondary' : 'text.primary'}
    >
        Quality v{version}
    </Typography>;


    if(!styled){
        return renderVersion;
    }

    return (
        <Box mt={{marginTop, marginBottom}} textAlign={align}>
            {renderVersion}
        </Box>
    );
};

export default AppVersion;